import { GET_BRAND_LIST } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';
import { IBrand } from '../../types/brand';

const brandListQueryKey = ['brand-list'];

const getBrandList = async (): Promise<{
  success: boolean;
  brands?: IBrand[];
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(GET_BRAND_LIST);
    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getBrandList, brandListQueryKey };